


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProjectOverviewItem } from '@/interfaces/ProjectOverviewItem';
import OverviewTable from '@/components/help/OverviewTable.vue';
import { Action } from 'vuex-class';
import { ProductGroupTypes } from '@/enums/ProductGroupTypes';

@Component({
    name: 'DatabaseOverviewDialog',
    components: {
        OverviewTable,
    },
})
export default class DatabaseOverviewDialog extends Vue {
    protected isListLoading = false;

    @Action('projects/getProjectOverview')
    protected getProjectOverview!: () => void;

    @Prop({
        required: true,
    })
    protected isDatabaseOverviewVisible!: boolean;

    protected mounted() {
        this.isListLoading = true;
        try {
            this.getProjectOverview();
        } catch (e) {
            this.$message.error(
                'There was an error fetching the database overview.',
            );
        } finally {
            this.isListLoading = false;
        }
    }

    private get projectOverview() {
        return this.$store.getters['projects/projectOverview'];
    }

    protected get activeProductGroup() {
        const type = this.$store.getters['user/activeProductGroup'];
        let message = '';
        if (type === ProductGroupTypes.Goodwill) {
            message = 'Goodwill';
        }
        if (type === ProductGroupTypes.Trademark) {
            message = 'Trademarks';
        }
        if (type === ProductGroupTypes.CustomerRelations) {
            message = 'Customer relations';
        }
        if (type === ProductGroupTypes.Technology) {
            message = 'Technology';
        }
        if (type === ProductGroupTypes.Software) {
            message = 'Software';
        }
        return message;
    }

    protected closeDialog() {
        this.$emit('closeDialog', 'view');
    }

    private get valuationCauses() {
        if (this.projectOverview == null) {
            return null;
        }
        return this.projectOverview.filter(
            (project: ProjectOverviewItem) => project.type === 'valuationCause',
        );
    }

    private get usdRevenues() {
        if (this.projectOverview == null) {
            return null;
        }
        return this.projectOverview
            .filter(
                (project: ProjectOverviewItem) =>
                    project.type === 'usdRevenues',
            )
            .reverse();
    }

    private get valuationYeaars() {
        if (this.projectOverview == null) {
            return null;
        }
        return this.projectOverview
            .filter(
                (project: ProjectOverviewItem) =>
                    project.type === 'valuationYear',
            )
            .sort(
                (po1: ProjectOverviewItem, po2: ProjectOverviewItem) =>
                    parseInt(po1.key) - parseInt(po2.key),
            )
            .reverse();
    }

    private get total() {
        if (this.projectOverview == null) {
            return null;
        }
        return this.projectOverview.filter(
            (project: ProjectOverviewItem) => project.type === 'totalCount',
        );
    }

    private separateThousands(value: string) {
        if (value == null) {
            return;
        }
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
}
